import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'parseMessage',
    standalone: false
})
export class ParseMessagePipe implements PipeTransform {
  transform(value: string): string {
    // make links clickable
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return value.replace(
      urlRegex,
      (url) => `<a href="${url}" class="link" target="_blank">${url}</a>`,
    );
  }
}
